import type { DealCardsAction, GameState, ValidationResult } from "../types";
import {
  validateHostAction,
  validateRoleCopyLimits,
  validateRoleSelectionCount,
  validateSetupPhase,
} from "./common";

export function validateDealCards(
  state: GameState,
  action: DealCardsAction,
): ValidationResult {
  const hostCheck = validateHostAction(
    state,
    action.actorPlayerId,
    "Only host can deal cards",
  );
  if (!hostCheck.valid) return hostCheck;

  const phaseCheck = validateSetupPhase(state);
  if (!phaseCheck.valid) return phaseCheck;

  if (!state.seatLocked) {
    return { valid: false, error: "Seat order must be locked before dealing" };
  }

  if (state.cards.length > 0) {
    return { valid: false, error: "Cards have already been dealt" };
  }

  const countCheck = validateRoleSelectionCount(state, state.selectedRoleIds);
  if (!countCheck.valid) return countCheck;

  return validateRoleCopyLimits(state.selectedRoleIds);
}
